export default __webpack_public_path__ + "9b3fd41472e6ebf9ec9a85d5bfdc98d8.png";